module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Silenen-9ffb1be3b13a8a92c4d84e5a7f053b2d.svg";